import { keys } from 'lodash';
import React, { useMemo, useRef, useState } from 'react';
import Modal, { Body, Header } from 'src/@vymo/ui/blocks/modal';
import Form from 'src/@vymo/ui/molecules/form';
import { FormVersion } from 'src/@vymo/ui/molecules/form/types';
import { useAppDispatch } from 'src/store/hooks';
import { getDefaultValues } from '../queries';
import { setSelectedTileData } from '../slice';
import { ShowFormActionProps } from '../types';
import styles from '../index.module.scss';

function ShowFormAction({
  action,
  widgetCode,
}: ShowFormActionProps): JSX.Element {
  const [open, setOpen] = useState(true);
  const formRef = useRef(null);
  const dispatch = useAppDispatch();

  const onCloseHandler = () => {
    setOpen(false);
    dispatch(setSelectedTileData({ widgetCode, data: {} }));
  };

  const convertedValues = useMemo(
    () => (formValues: Record<string, unknown>) => {
      const updatedValues = keys(formValues).map((item) => ({
        [item]: formValues[item],
      }));
      const values = getDefaultValues(Object.assign({}, ...updatedValues));
      return values;
    },
    [],
  );

  const handleFormChange = () => {};

  return (
    <Modal
      open={open}
      showCloseButton
      closeOnEscape
      onClose={onCloseHandler}
      classNames={styles.spg__modal}
    >
      <Header>
        <h2>{action.title}</h2>
      </Header>
      <Body>
        <Form
          key="spg_show_form"
          ref={formRef}
          id="spgShowForm"
          name="spgShowForm"
          onChange={handleFormChange}
          className={styles.form}
          span="1fr"
          config={{
            version: FormVersion.web,
            data: action?.content_data?.inputs || [],
            grouping: 'card',
            fieldItemConfig: {
              showDisabledIcon: true,
            },
            groupConfig: {
              collapsibleClasses: styles.form__collapsible,
            },
            viewMode: true,
          }}
          formulaContext={{
            data: {
              vo: { inputs_map: action?.content_data?.inputs_map ?? {} },
            },
          }}
          value={convertedValues(action?.content_data?.inputs_map ?? {})}
        />
      </Body>
    </Modal>
  );
}

export default ShowFormAction;
